module.exports = __webpack_public_path__ + "static/media/thinking-emoji-svgrepo-com (1).56ef7443.svg";